var map = {
	"./3-simple-email-leave-request-templates.md": [
		4652,
		652
	],
	"./autumn-uk-budget-2024-payroll-changes.md": [
		7995,
		995
	],
	"./future-of-payroll-services.md": [
		9481,
		481
	],
	"./how-to-choose-a-payroll-software.md": [
		1833,
		833
	],
	"./ivf-leave.md": [
		302,
		302
	],
	"./key-payroll-features-for-future-proofing.md": [
		765,
		765
	],
	"./national-payroll-week-the-business-impact-of-stellar-payroll-management.md": [
		2700,
		700
	],
	"./notice-period.md": [
		3001
	],
	"./overtime-and-excess-hours.md": [
		9160,
		160
	],
	"./payslip.md": [
		9339
	],
	"./pricing-update-jan-2022.md": [
		2470,
		470
	],
	"./sick-leave.md": [
		2983,
		983
	],
	"./sickness-benefit.md": [
		7540,
		540
	],
	"./the-new-eu-work-life-balance-for-parents-and-carers-what-you-need-to-know.md": [
		5561,
		561
	],
	"./why-you-may-be-underpaying-or-overpaying-your-employees.md": [
		8165,
		165
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 514;
module.exports = webpackAsyncContext;